import { render, staticRenderFns } from "./SecCardsItem.vue?vue&type=template&id=857e0ffc&scoped=true&"
import script from "./SecCardsItem.vue?vue&type=script&lang=js&"
export * from "./SecCardsItem.vue?vue&type=script&lang=js&"
import style0 from "./SecCardsItem.vue?vue&type=style&index=0&id=857e0ffc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857e0ffc",
  null
  
)

export default component.exports